import './Education.css';
import './scrollAnimations.css';
import { useEffect } from 'react';

import FAITH from './IMAGE/FAITH.jpg';
import APEC from './IMAGE/APEC.webp';
import INOS from './IMAGE/INOS.jpg';
import useScrollAnimation from './useScrollAnimation';

const CourseSvg = ({ type }) => {
  if (type === 'Hardware') return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line></svg>;
  if (type === 'Software') return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline></svg>;
  return <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>;
};

function Education({ onNavigateHome }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  return (
    <div className="edu-page">

      {/* ── Header ── */}
      <header className="edu-header">
        <div className="edu-header-inner">
          <button className="edu-back-btn" onClick={onNavigateHome}>
            <span className="edu-back-arrow">&#8592;</span> Back to Portfolio
          </button>
          <nav className="edu-breadcrumb">
            <span className="edu-bc-home" onClick={onNavigateHome}>Home</span>
            <span className="edu-bc-sep">/</span>
            <span className="edu-bc-current">Education</span>
          </nav>
        </div>
      </header>

      {/* ── Hero Strip ── */}
      <div className="edu-hero-strip">
        <div className="edu-strip-inner">
          <p className="edu-strip-label scroll-animate-hero" data-delay="0">Academic Background</p>
          <h1 className="edu-strip-name scroll-animate-hero" data-delay="100">Education</h1>
          <p className="edu-strip-role scroll-animate-hero" data-delay="200">My academic journey in Computer Engineering</p>
        </div>
      </div>

      {/* ── Main Content ── */}
      <main className="edu-main">

        {/* ═══ CURRENT SCHOOL ═══ */}
        <section className="edu-section scroll-animate" data-delay="0">
          <div className="edu-sec-header">
            <span className="edu-sec-num">01</span>
            <h2 className="edu-sec-title">Current School</h2>
            <div className="edu-sec-rule"></div>
          </div>

          <div className="edu-school-card edu-school-current">
            <div className="edu-school-cover">
              <img src={FAITH} alt="FAITH Colleges Campus" className="edu-school-cover-img" />
              <div className="edu-school-cover-overlay">
                <div className="edu-school-badge-wrap">
                  <span className="edu-school-badge">Current</span>
                  <span className="edu-school-year-overlay">2022 — 2026</span>
                </div>
                <h3 className="edu-school-name-overlay">FAITH Colleges</h3>
                <p className="edu-school-location-overlay">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px' }}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                  Batangas, Philippines
                </p>
              </div>
            </div>

            <div className="edu-school-content">
              <div className="edu-stats-grid">
                <div className="edu-stat-box">
                  <div className="edu-stat-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg>
                  </div>
                  <div className="edu-stat-text">
                    <span className="edu-stat-label">Degree Program</span>
                    <span className="edu-stat-val">BS Computer Engineering</span>
                  </div>
                </div>
                <div className="edu-stat-box">
                  <div className="edu-stat-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line></svg>
                  </div>
                  <div className="edu-stat-text">
                    <span className="edu-stat-label">Year Level</span>
                    <span className="edu-stat-val">3rd Year Standing</span>
                  </div>
                </div>
                <div className="edu-stat-box">
                  <div className="edu-stat-icon" style={{ background: 'transparent', border: 'none' }}>
                    <div className="edu-status-pulse"></div>
                  </div>
                  <div className="edu-stat-text">
                    <span className="edu-stat-label">Status</span>
                    <span className="edu-stat-val">Currently Enrolled</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ═══ ACADEMIC FOCUS & SPECIALIZATION ═══ */}
        <section className="edu-section scroll-animate" data-delay="0">
          <div className="edu-sec-header">
            <span className="edu-sec-num">02</span>
            <h2 className="edu-sec-title">Academic Focus <span style={{ fontFamily: "'Inter', sans-serif" }}>&amp;</span> Specialization</h2>
            <div className="edu-sec-rule"></div>
          </div>

          <div className="edu-focus-grid">
            <div className="edu-focus-card">
              <div className="edu-focus-icon">&#x2301;</div>
              <h3 className="edu-focus-name">FPGA &amp; Digital Design</h3>
              <p className="edu-focus-desc">
                Designing and verifying digital logic circuits using Verilog/VHDL on FPGA platforms with tools like Quartus Prime and Vivado.
              </p>
              <div className="edu-focus-tags">
                <span className="edu-ftag">Verilog</span>
                <span className="edu-ftag">VHDL</span>
                <span className="edu-ftag">Quartus</span>
              </div>
            </div>
            <div className="edu-focus-card">
              <div className="edu-focus-icon">&#x2699;</div>
              <h3 className="edu-focus-name">Embedded &amp; IoT Systems</h3>
              <p className="edu-focus-desc">
                Building microcontroller-based solutions with ESP32 and Arduino for real-world automation and IoT applications.
              </p>
              <div className="edu-focus-tags">
                <span className="edu-ftag">ESP32</span>
                <span className="edu-ftag">Arduino</span>
                <span className="edu-ftag">MicroPython</span>
              </div>
            </div>
            <div className="edu-focus-card">
              <div className="edu-focus-icon">&#x2756;</div>
              <h3 className="edu-focus-name">Full-Stack Web Development</h3>
              <p className="edu-focus-desc">
                Creating responsive, modern web applications using React.js, Node.js, Firebase, and modern CSS frameworks.
              </p>
              <div className="edu-focus-tags">
                <span className="edu-ftag">React</span>
                <span className="edu-ftag">Node.js</span>
                <span className="edu-ftag">Firebase</span>
              </div>
            </div>
          </div>
        </section>

        {/* ═══ RELEVANT COURSEWORK ═══ */}
        <section className="edu-section scroll-animate" data-delay="0">
          <div className="edu-sec-header">
            <span className="edu-sec-num">03</span>
            <h2 className="edu-sec-title">Relevant Coursework</h2>
            <div className="edu-sec-rule"></div>
          </div>

          <div className="edu-course-grid">
            {[
              { cat: 'Hardware', name: 'Mixed Signals and Sensors' },
              { cat: 'Engineering', name: 'Data Structures & Algorithms' },
              { cat: 'Hardware', name: 'Embedded Systems' },
              { cat: 'Software', name: 'CPE-MIC' },
              { cat: 'Software', name: 'CPE-MIC 1' },
              { cat: 'Software', name: 'CPE-MIC 2' },
              { cat: 'Software', name: 'CPE-HDL' },
              { cat: 'Software', name: 'Object-Oriented Programming' },
              { cat: 'Engineering', name: 'Engineering Economics' },
              { cat: 'Software', name: 'Software Design' },
              { cat: 'Hardware', name: 'Feedback & Control Systems' },
              { cat: 'Hardware', name: 'Digital Signal Processing' },
            ].map(({ cat, name }) => (
              <div className="edu-course-card" key={name}>
                <div className="edu-course-icon"><CourseSvg type={cat} /></div>
                <div className="edu-course-info">
                  <span className="edu-course-cat">{cat}</span>
                  <span className="edu-course-name">{name}</span>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ═══ PREVIOUS EDUCATION ═══ */}
        <section className="edu-section scroll-animate" data-delay="0">
          <div className="edu-sec-header">
            <span className="edu-sec-num">04</span>
            <h2 className="edu-sec-title">Previous Education</h2>
            <div className="edu-sec-rule"></div>
          </div>

          {/* ── SHS + JHS side-by-side cards ── */}
          <div className="edu-prev-grid">
            {/* SENIOR HIGH SCHOOL card */}
            <div className="edu-prev-card">
              <div className="edu-prev-banner edu-prev-banner-shs">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"></path><path d="M6 12v5c3 3 9 3 12 0v-5"></path></svg>
                <span>SENIOR HIGH SCHOOL</span>
              </div>
              <div className="edu-prev-photo">
                <img src={APEC} alt="APEC Schools Campus" className="edu-prev-photo-img" />
                <div className="edu-prev-photo-overlay">
                  <span className="edu-prev-year">2020 — 2022</span>
                  <h4 className="edu-prev-school-name">APEC Schools</h4>
                  <p className="edu-prev-school-loc">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '5px' }}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                    Lipa, Batangas
                  </p>
                </div>
              </div>
              <div className="edu-prev-details">
                <div className="edu-prev-detail-row">
                  <span className="edu-prev-detail-label">STRAND</span>
                  <span className="edu-prev-detail-val">STEM</span>
                </div>
                <div className="edu-prev-detail-row">
                  <span className="edu-prev-detail-label">AWARD</span>
                  <span className="edu-prev-detail-val">Merit Award</span>
                </div>
                <p className="edu-prev-desc">
                  Took the STEM strand which deepened my foundation in science, mathematics, and critical thinking. Graduated with a Merit Award for maintaining strong academic performance throughout senior high.
                </p>
              </div>
            </div>

            {/* JUNIOR HIGH SCHOOL card */}
            <div className="edu-prev-card">
              <div className="edu-prev-banner edu-prev-banner-jhs">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
                <span>JUNIOR HIGH SCHOOL</span>
              </div>
              <div className="edu-prev-photo">
                <img src={APEC} alt="APEC Schools Campus" className="edu-prev-photo-img" />
                <div className="edu-prev-photo-overlay">
                  <span className="edu-prev-year">2016 — 2020</span>
                  <h4 className="edu-prev-school-name">APEC Schools</h4>
                  <p className="edu-prev-school-loc">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '5px' }}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                    Lipa, Batangas
                  </p>
                </div>
              </div>
              <div className="edu-prev-details">
                <div className="edu-prev-detail-row">
                  <span className="edu-prev-detail-label">LEVEL</span>
                  <span className="edu-prev-detail-val">Completed Junior High School</span>
                </div>
                <p className="edu-prev-desc">
                  Completed my junior high school years at APEC Schools where I first discovered my passion for technology and problem-solving. This period built the discipline and curiosity that guided me toward engineering.
                </p>
              </div>
            </div>
          </div>

          {/* ── Elementary card (original format) ── */}
          <div className="edu-school-card edu-school-past" style={{ marginTop: '32px' }}>
            <div className="edu-school-cover edu-school-cover-sm">
              <img src={INOS} alt="Inosloban-Marawoy Elementary Campus" className="edu-school-cover-img" />
              <div className="edu-school-cover-overlay">
                <div className="edu-school-badge-wrap">
                  <span className="edu-school-year-overlay">2010 — 2016</span>
                </div>
                <h3 className="edu-school-name-overlay">Inosloban-Marawoy Elementary</h3>
                <p className="edu-school-location-overlay">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ marginRight: '6px' }}><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle></svg>
                  Batangas
                </p>
              </div>
            </div>

            <div className="edu-school-content">
              <div className="edu-stats-grid" style={{ gridTemplateColumns: '1fr' }}>
                <div className="edu-stat-box">
                  <div className="edu-stat-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
                  </div>
                  <div className="edu-stat-text">
                    <span className="edu-stat-label">Extracurricular</span>
                    <span className="edu-stat-val">Sports Writing</span>
                  </div>
                </div>
              </div>
              
              <div style={{ height: '1px', background: 'rgba(102, 126, 234, 0.1)', margin: '32px 0 24px' }}></div>
              <p className="edu-prev-desc" style={{ margin: 0 }}>
                Where it all began — Inosloban-Marawoy Elementary gave me my earliest experiences in academics and extracurriculars. I participated in sports writing competitions which sparked my love for storytelling and communication.
              </p>
            </div>
          </div>
        </section>

        {/* ═══ ACADEMIC DETAILS ═══ */}
        <section className="edu-section scroll-animate" data-delay="0">
          <div className="edu-sec-header">
            <span className="edu-sec-num">05</span>
            <h2 className="edu-sec-title">Academic Highlights</h2>
            <div className="edu-sec-rule"></div>
          </div>

          <div className="edu-highlights-grid">
            <div className="edu-highlight-card">
              <div className="edu-hl-num">4x</div>
              <div className="edu-hl-label">Dean's Lister</div>
              <div className="edu-hl-detail">FAITH Colleges · 2023–2025</div>
            </div>
            <div className="edu-highlight-card">
              <div className="edu-hl-num">★</div>
              <div className="edu-hl-label">Merit Award</div>
              <div className="edu-hl-detail">APEC Schools · 2023</div>
            </div>
            <div className="edu-highlight-card">
              <div className="edu-hl-num">◆</div>
              <div className="edu-hl-label">With High Honors</div>
              <div className="edu-hl-detail">Langka Elementary · 2012</div>
            </div>
            <div className="edu-highlight-card">
              <div className="edu-hl-num">10+</div>
              <div className="edu-hl-label">Lab Projects</div>
              <div className="edu-hl-detail">FPGA, Embedded, Web, PCB</div>
            </div>
          </div>
        </section>

      </main>

      {/* ── Footer ── */}
      <footer className="edu-footer scroll-animate">
        <p>Christian D. Kalaw &copy; {new Date().getFullYear()}</p>
        <button className="edu-footer-back" onClick={onNavigateHome}>Back to Portfolio</button>
      </footer>

    </div>
  );
}

export default Education;
